import './App.css';

import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

import { Header } from './components/Header'; 

import { Home         } from './routes/Home';
import { About        } from './routes/About';
import { Treatments   } from './routes/Treatments';
import { Rates        } from './routes/Rates';
import { Appointments } from './routes/Appointments';
import { Policies     } from './routes/Policies';
import { Reviews      } from './routes/Reviews';
import { Benefits     } from './routes/Benefits';
import { NoMatch      } from './routes/NoMatch';   

function Layout() {
  return (
    <div>
      <Header />
      <div style={{ padding: '10px 25px' }}>
        {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
        <Outlet />
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout/>}>
            <Route index               element={<Home/> } />
            <Route path="about"        element={<About/>} />
            <Route path="treatments"   element={<Treatments/>} />
            <Route path="rates"         element={<Rates/>} />
            <Route path="appointments" element={<Appointments/>} />
            <Route path="policies"     element={<Policies />} />
            <Route path="reviews"      element={<Reviews />} />
            <Route path="benefits"     element={<Benefits />} />

            {/* Using path="*"" means "match anything", so this route
                  acts like a catch-all for URLs that we don't have explicit
                  routes for. */}
            <Route path="*" element={<NoMatch />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
